<template>
    <a class="avatar" :class="{ 'avatar--with-image': hasAvatar }">
        <img v-if="hasAvatar" :src="userAvatarUrl" />
        <template class="avatar__letter" v-else>{{ userDisplayName | firstLetter }}</template>
    </a>
</template>

<script>
import { mapGetters } from 'vuex';

const userGetters = ['userDisplayName', 'userAvatarUrl'];

export default {
    name: 'Avatar',

    filters: {
        firstLetter(v) {
            return v.slice(0, 1);
        },
    },

    computed: {
        ...mapGetters('auth', userGetters),

        hasAvatar() {
            return !!this.userAvatarUrl;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables.scss';

.avatar {
    width: mrem(45);
    height: mrem(45);
    border-radius: 50%;
    background-color: $color-main-primary;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-family: $font-main;
    font-style: normal;
    font-weight: bold;
    font-size: mrem(18);
    line-height: mrem(26);
    @include on-desktop {
      font-size: rem(22);
      line-height: rem(22);
    }


    &--with-image {
        width: mrem(45);
        height: mrem(45);
        background-color: #ffffff;
        border: mrem(2) solid $color-main-primary;
    }

    img {
        width: mrem(40);
        height: mrem(40);
        border-radius: 50%;
    }
}
</style>
